import React from 'react'
import { useCurrentCloudProvider } from '../../utils/hooks/useCurrentCloudProvider'
import { MarketplaceIcon } from './MarketplaceIcon'
import { useStyles } from './SelectedCloudIcon.styles'

export const SelectedCloudIcon: React.FC = () => {
  const { classes } = useStyles()
  const cloudMarketplace = useCurrentCloudProvider()

  return cloudMarketplace ? (
    <div className={classes.productNameContainer} data-testid="cloud-container">
      <MarketplaceIcon classes={classes} cloudMarketplace={cloudMarketplace} />
    </div>
  ) : (
    <div data-testid="empty-cloud"></div>
  )
}
